import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Spinner } from "@/components/Shared";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setError("Password must be at least 8 characters.");
    if (pw !== pw2) return setError("Passwords do not match.");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Choose a password" sub="Use at least 8 characters.">
      {done ? (
        <div className="space-y-4" data-testid="reset-success">
          <p className="rounded-md border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-800">Your password has been set. You can sign in now.</p>
          <Link to="/login" className="btn-brand h-14 w-full" data-testid="reset-go-login">Sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <input type="password" placeholder="New password" className="field-input" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" />
          <input type="password" placeholder="Confirm password" className="field-input" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm-input" />
          {!token && <p className="text-sm text-red-600">This link is missing its token. Request a new reset email.</p>}
          {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
          <button className="btn-brand h-14 w-full" disabled={busy || !token} data-testid="reset-submit-button">{busy && <Spinner className="text-white" />}Set password</button>
        </form>
      )}
    </AuthShell>
  );
}
